<template lang="pug">
.container-fluid
	.row
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
			.card
				.card-header.bg-dark.text-white
					span.fa.fa-filter.mr-2
					| Selecciona

				.card-body
					.row
						.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
							.form-group
								label
									b Año
								input.form-control(v-model.number="filtro.ano")
						.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
							.form-group
								label
									b Soporte
								select.form-control(v-model="filtro.SoporteID")
									option(
										v-for="soporte in listadoSoportes"
										:key="soporte.ID_soporte"
										:value="soporte.ID_soporte"
									) {{soporte.soporte}}
						.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
							.form-group
								label
									b Producto
								select.form-control(v-model="filtro.ProductoID")
									option(
										v-for="producto in listadoProductos"
										:key="producto.ID_producto"
										:value="producto.ID_producto"
									) {{producto.nombre}}
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6(v-if="formValido")
			.card
				.card-header.bg-warning
					span.fa.fa-list.mr-2
					| {{tituloTarifas}}
				table.table.table-striped.m-0
					thead
						tr
							th ID
							th Duración
							th Unitario
							th Unidades
							th Precio
							th Modificar
					tbody(v-if="tarifas && tarifas.length > 0")
						tr(
							v-for="tarifa in tarifas"
							:key="tarifa.ID_tarifa"
						)
							th {{tarifa.ID_tarifa}}
							th
								div(v-if="!editando || editando.ID_tarifa !== tarifa.ID_tarifa") {{tarifa.duracion}}
								div(v-else)
									input.form-control(v-model.number="editando.duracion")
							th
								span.fa.fa-check(v-if="tarifa.duracion === 1")
								span.fa.fa-ban(v-else)
							th
								div(v-if="!editando || editando.ID_tarifa !== tarifa.ID_tarifa") {{tarifa.unidades}}
								div(v-else)
									select.form-control(v-model="editando.unidades")
										option(value="segundos") Segundos
										option(value="minutos") Minutos
							th
								div(v-if="!editando || editando.ID_tarifa !== tarifa.ID_tarifa") {{tarifa.precio | currency('')}} €
								div(v-else)
									input.form-control(v-model.number="editando.precio")
							th
								div(v-if="!editando")
									button.btn.btn-sm.btn-warning(@click="editando = tarifa")
										span.fa.fa-edit
								div(v-if="editando && editando.ID_tarifa === tarifa.ID_tarifa")
									button.btn.btn-sm.btn-primary.mr-3(@click="setTarifa()")
										span.fa.fa-save
									button.btn.btn-sm.btn-danger(@click="cancelarEdicion")
										span.fa.fa-close

				.card-footer(v-if="!editando")
					button.btn.btn-primary(@click="nuevaTarifa")
						span.fa.fa-plus.mr-2
						| Añadir
	nuevo-producto(v-if="nuevoProducto", @cerrar="nuevoProducto = null", @nuevo="productoCreado($event)", :producto="nuevoProducto")
</template>

<script>
import axios from 'axios'
import NuevoProducto from './componentes/nuevoProducto'
export default {
	components: {
		'nuevo-producto': NuevoProducto
	},
	data () {
		return {
			filtro: {
				ano: new Date().getFullYear(),
				SoporteID: null,
				ProductoID: null
			},
			editando: null,
			nuevoProducto: null,
			listadoSoportes: [],
			listadoProductos: [],
			tarifas: [],
			idNueva: 0
		}
	},
	computed: {
		formValido: function () {
			return (this.filtro.ano && this.filtro.SoporteID && this.filtro.ProductoID && this.filtro.ProductoID !== 'nuevo')
		},
		tituloTarifas: function () {
			if (!this.formValido) {
				return null
			}

			let cadena = this.filtro.ano.toString() + ': '

			for (let i = 0; i < this.listadoSoportes.length; i++) {
				if (this.listadoSoportes[i].ID_soporte === this.filtro.SoporteID) {
					cadena = cadena + this.listadoSoportes[i].soporte + ' - '
				}
			}

			for (let i = 0; i < this.listadoProductos.length; i++) {
				if (this.listadoProductos[i].ID_producto === this.filtro.ProductoID) {
					cadena = cadena + this.listadoProductos[i].nombre
				}
			}

			return cadena
		}
	},
	created () {
		this.getSoportes()
	},
	watch: {
		'filtro.ano': function () {
			this.tarifas = []
			this.getTarifas()
		},
		'filtro.SoporteID': function () {
			this.tarifas = []
			this.filtro.ProductoID = null
			this.listadoProductos = []
			this.getProductos()
		},
		'filtro.ProductoID': function (newVal) {
			if (newVal === 'nuevo') {
				this.nuevoProducto = {
					ID_producto: null,
					nombre: null,
					soporte_ID: this.filtro.SoporteID
				}
			} else {
				this.getTarifas()
			}
		}
	},
	methods: {
		getSoportes () {
			axios.get('gestion-tarifas/php/api/get-soportes.php')
				.then(res => {
					this.listadoSoportes = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		productoCreado (ID) {
			this.filtro.ProductoID = ID
			this.getProductos()
		},
		getProductos () {
			if (!this.filtro.SoporteID) {
				return
			}

			axios.post('gestion-tarifas/php/api/get-productos.php', {SoporteID: this.filtro.SoporteID})
				.then(res => {
					this.listadoProductos = res.data

					this.listadoProductos.push({
						ID_producto: 'nuevo',
						nombre: 'Crear nuevo',
						soporte_ID: this.filtro.SoporteID
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getTarifas () {
			if (!this.filtro.ano || typeof this.filtro.ano !== 'number') {
				return
			}

			if (!this.filtro.SoporteID) {
				return
			}

			if (!this.filtro.ProductoID) {
				return
			}

			axios.post('gestion-tarifas/php/api/get-tarifas.php', this.filtro)
				.then(res => {
					this.tarifas = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevaTarifa () {
			const ID = 'N-' + (++this.idNueva)
			const tarifa = {
				ID_tarifa: ID,
				duracion: null,
				unidades: 'segundos',
				precio_unitario: null,
				producto_ID: this.filtro.ProductoID,
				ano: this.filtro.ano
			}

			this.tarifas.push(tarifa)
			this.editando = tarifa
		},
		cancelarEdicion () {
			if (this.editando && typeof this.editando.ID_tarifa === 'string' && this.editando.ID_tarifa.match(/^N/)) {
				this.tarifas = this.tarifas.filter(t => t.ID_tarifa !== this.editando.ID_tarifa)
			}

			this.editando = null
		},
		setTarifa () {
			const form = JSON.parse(JSON.stringify(this.editando))
			if (typeof form.ID_tarifa === 'string' && form.ID_tarifa.match(/^N/)) {
				form.ID_tarifa = null
			}
			axios.post('gestion-tarifas/php/api/set-tarifa.php', form)
				.then(res => {
					this.editando = null
					this.getTarifas()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-tarifas/vue/Main.vue